module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("区域农业投入品流通销售排行榜")]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item,
      staticClass: "type",
      class: {
        active: index == _vm.typeindex
      },
      on: {
        "click": function($event) {
          return _vm.changeType(item, index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "list-item"
    }, [_c('i', {
      staticClass: "item-rank",
      style: (_vm.changeColor(index))
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "item1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "item2"
    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
      staticClass: "item3"
    }, [_vm._v(_vm._s(item.lumpSum))])])
  }), 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item1"
  }, [_c('div', {
    staticClass: "item1"
  }, [_vm._v("排名")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("商品名")]), _vm._v(" "), _c('div', {
    staticClass: "item2"
  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
    staticClass: "item3"
  }, [_vm._v("数量")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49027a72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/yinxiao/components/table/index.vue
// module id = 1994
// module chunks = 2